import { useState, useEffect } from "react";
import { fetchNews } from "../../../store/cache";
import { useSelector, useDispatch } from "react-redux";

import "./index.css";

const NewsItemComponent = ({data}) => {
    return (
        <div className='news-item'>
            <h3>{data.title}</h3>
            <div className='news-item-text'>
                <p>{data.text}</p>
            </div>
        </div>
    );
};

const NewsComponent = () => {
    const dispatch = useDispatch();
    const news = useSelector(state => state?.cache?.news);
    const [startId, setStartId] = useState(1);

    useEffect(() => {
        if (!news) dispatch(fetchNews(startId));
    }, [news, startId, dispatch]);

    const onClickNewsButton = (id) => {
        if (id === 1) {
            const newId = startId + 5;
            setStartId(newId)
            dispatch(fetchNews(newId));
        } else {
            const newId = startId - 5;
            setStartId(newId)
            dispatch(fetchNews(newId));
        };
    };

    if (!news) return <div id='news-container'><p>Loading...</p></div>;
    return (
        <div id='news-container'>
            <div id='news-background-top-container'>

                <div id='news-background-middle-container'>
                    <div id='news-item-container'>
                        {news?.map((el, i) => <NewsItemComponent key={el.id} data={el}/>)}
                    </div>

                    <div id='news-button-container'>
                        {startId > 1 && <button className='button'
                            onClick={() => onClickNewsButton()}
                        >Back</button>}

                        {news.length >= 5 && <button className='button'
                            onClick={() => onClickNewsButton(1)}
                        >More News</button>}
                    </div>
                </div>

                <div id='news-background-bottom-container'>
                </div>

            </div>
        </div>
    );
};

export default NewsComponent;